
import React, {  useLayoutEffect, useRef, useState } from "react";
import WaveSurfer from "wavesurfer.js";
//import { toastInformation } from "../../../../base/callService/common";

const formWaveSurferOptions = (ref:any) => ({
  container: ref,
  waveColor: "#D3D6DE",
  progressColor: "#439CF3",
  cursorColor: "#439CF3",
  barWidth: 3,
  barRadius: 2,
  responsive: true,
  height: 12,
  barMinHeight: 15,
  barGap: 2,
  width: 60,
  // If true, normalize by the maximum peak instead of 1.0.
  normalize: true,
  // Use the PeakCache to improve rendering speed of large waveforms.
  partialRender: true
  
});


type WaveFormVoicemailProps={
  voiceValues?: any;
  recordUrl?: any;
  // errorwave?:any
}

export default function WaveFormLeft({voiceValues, recordUrl}:WaveFormVoicemailProps) {
  const waveformRef:any = useRef(null);
  const wavesurfer: any = useRef(null);
  const duration:any = useRef(null);
 
  const [playing, setPlay] = useState(false);
  //const [volume, setVolume] = useState(0.5);
  const [Loaded, setloaded] = useState(false);
  
  useLayoutEffect (() => {
  /* starting itself player have to play or pause */
    setPlay(false);
    console.log("useeffect");
    const options = formWaveSurferOptions(waveformRef.current);
    wavesurfer.current = WaveSurfer.create(options);
    // if (!(_.isEmpty(recordUrl)) || !(_.isEmpty(voiceValues))) {
    //   let url:string = voiceValues?.wavUrl ? voiceValues?.wavUrl
    //     :  recordUrl?.recordingUrl ? recordUrl?.recordingUrl : "";
    //   wavesurfer.current.load(url);
    // }
    wavesurfer.current.load(voiceValues?.wavurl);

    wavesurfer.current.on("ready", function() {
      setloaded(true);
        // // make sure object stillavailable when file loaded
        // if (wavesurfer.current) {
        //   wavesurfer.current.setVolume(volume);
        //   setVolume(volume);
        // } 
    });
    wavesurfer.current.on("error", function(error:any){
      setloaded(false);
      //errorwave(true);
      if (error !== "Error decoding audiobuffer") {
        // toastInformation('Corrupted  Audio Source',"failure");
      }
    });
    wavesurfer.current.on("audioprocess", function() {
      if (wavesurfer.current.isPlaying) {
        duration.current = wavesurfer.current.getDuration();
      }
    });
    wavesurfer.current.on("finish", function() {
      console.log("finish");
      setPlay(false);
    });
 
    return () => {
      wavesurfer.current.destroy();setloaded(false);
    };
  }, [voiceValues, recordUrl]);

  const handlePlayPause = () => {
    setPlay(!playing);
    wavesurfer.current.playPause();
  };

  // const onVolumeChange = (e:any) => {
  //   const { target } = e;
  //   const newVolume = +target.value;

  //   if (newVolume) {
  //     setVolume(newVolume);
  //     wavesurfer.current.setVolume(newVolume || 1);
  //   }
  // };
  return (
    <>
      <div className="voicemailAudioLeft leftaudios">
        {Loaded &&
          <p><span onClick={handlePlayPause} className={!playing ? "icon_play" : "icon_pausebar"}></span></p>
        }
        <div id="waveform" ref={waveformRef} />
      </div>
    </>
  );
}